import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';
import { Preferences } from '../../profile/objects/preferences';
import { DEFAULT_COLUMN, MANUAL_ACTIVITY_MODULE } from '../constant/manualActivityConstant';
import { Column } from '../objects/column';

export const setManualActivityPreference = (
    new_preferences: Preferences[],
    state_columns: Column[],
): ListPreferenceResult => setListPreference(new_preferences, state_columns, {
    module: MANUAL_ACTIVITY_MODULE,
    default_columns: DEFAULT_COLUMN,
    default_order_by: '-created_date',
    default_order: 'asc',
});
